import { useBemCN } from '@gik/core/utils/bemBlock';
import { UI } from '@gik/ui';
import React, { useEffect } from 'react';
import { PaymentConfirmationValues } from '../../types';
import PremiumPageUpgradeThankYou from '../PremiumPageUpgradeThankYou/PremiumPageUpgradeThankYou';
import PaymentConfirmation from './PaymentConfirmation';

export interface PremiumPageUpgradePaymentConfirmationProps extends React.HTMLAttributes<HTMLDivElement> {
  values: PaymentConfirmationValues;
  productName: string;
}

export default function PremiumPageUpgradePaymentConfirmation({
  className,
  values,
  productName,
  ...otherProps
}: PremiumPageUpgradePaymentConfirmationProps): React.ReactElement {
  useEffect(() => {
    UI.notifyPremiumPageUnlocked();
  }, []);

  const bem = useBemCN('premium-page-upgrade-payment-confirmation');

  return (
    <>
      <PaymentConfirmation
        header={
          <>
            <PremiumPageUpgradeThankYou />
            <br className="xl" />
          </>
        }
        renderDefaultThankYou={false}
        values={values}
        productName={productName}
        shipping={false}
        {...bem(undefined, undefined, className)}
        {...otherProps}
      />
    </>
  );
}
